module.exports = __webpack_public_path__ + "img/bobMenuIcon.a7f2bc89.svg";